import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'

/* Layout */
import Layout from '@/layout/index.vue'
import { alertRoutes } from '@/modules/module-alerts/router/alert-routes'
import { factoryDashboardRoutes } from '@/modules/module-factory-dashboard/router/factory-dashboard-routes'
import { factoryStudioRoutes } from '@/modules/module-factory-studio/router/factory-studio-routes'
/* Router modules */
import { logs } from '@/modules/module-logs/router/logs'
import { performanceDashboardRoutes } from '@/modules/module-performance-dashboard/router/performance-dashboard-routes'
import { publicApiDashboardRoutes } from '@/modules/module-public-api-dashboard/router/public-api-dashboard-routes'

/**
 ConstantRoutes
 a base page that does not have permission requirements
 all roles can be accessed
 */
export const constantRoutes: RouteRecordRaw[] = [
  {
    path: '/',
    redirect: '/applications',
    meta: { hidden: true },
  },
  {
    path: '/login',
    component: () => import('@/views/login/index.vue'),
    meta: { hidden: true },
  },
  // {
  //   path: '/applications',
  //   component: Layout,
  //   children: [
  //     {
  //       path: '/',
  //       component: () => import('@/views/applications/index.vue'),
  //       name: 'Applications',
  //       meta: { hidden: true },
  //     },
  //   ],
  // },
  {
    path: '/applications',
    component: () => import('@/views/applications/index.vue'),
    name: 'Applications',
    meta: { hidden: true, layout: Layout },
  },
  {
    path: '/profile',
    component: Layout,
    children: [
      {
        path: 'password',
        components: {
          default: () => import('@/views/profile/change-password/index.vue'),
          sidebar: () => import('@/views/profile/sidebar/index.vue'),
        },
        name: 'ChangePassword',
        meta: { title: 'profile.changePassword' },
      },
      {
        path: 'notifications',
        components: {
          default: () => import('@/views/profile/notifications/index.vue'),
          sidebar: () => import('@/views/profile/sidebar/index.vue'),
        },
        name: 'Notifications',
        meta: { title: 'profile.notifications' },
      },
      {
        path: 'appearance',
        components: {
          default: () => import('@/views/profile/appearance/index.vue'),
          sidebar: () => import('@/views/profile/sidebar/index.vue'),
        },
        name: 'Appearance',
        meta: { title: 'profile.appearance' },
      },
    ],
  },
  {
    path: '/watcher',
    component: () => import('@/views/watcher/index.vue'),
    name: 'Watcher',
    meta: { hidden: true, layout: Layout },
  },
  ...alertRoutes,
]

export const route404: RouteRecordRaw[] = [
  {
    path: '/:pathMatch(.*)*',
    component: () => import('@/views/errors/404.vue'),
    name: 'NotFound',
    meta: { hidden: true },
  },
]

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
export const asyncRoutes: RouteRecordRaw[] = [
  ...logs,
  ...factoryDashboardRoutes,
  ...factoryStudioRoutes,
  ...performanceDashboardRoutes,
  ...publicApiDashboardRoutes,
]

export const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition
    }
    return { left: 0, top: 0 }
  },
  routes: [...constantRoutes, ...asyncRoutes, ...route404],
})

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter({
    history: createWebHistory(),
    routes: constantRoutes,
  })
  ;(router as any).matcher = (newRouter as any).matcher // reset router
}
